import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const { setUser } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = location.hash || window.location.hash;
        const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
        if (!sessionId) { navigate("/login"); return; }
        (async () => {
            try {
                const { data } = await api.post("/auth/session", { session_id: sessionId });
                setUser(data);
                window.history.replaceState(null, "", "/dashboard");
                navigate("/dashboard", { replace: true });
            } catch {
                navigate("/login", { replace: true });
            }
        })();
    }, [location, navigate, setUser]);

    return (
        <div className="min-h-screen grid place-items-center bg-background">
            <div className="text-center"><Loader2 className="h-8 w-8 animate-spin text-primary mx-auto" /><p className="mt-3 text-sm text-foreground/60">Signing you in…</p></div>
        </div>
    );
}
